import { render, staticRenderFns } from "./TeakManagement.vue?vue&type=template&id=6d8ec1ba&scoped=true&"
import script from "./TeakManagement.vue?vue&type=script&lang=js&"
export * from "./TeakManagement.vue?vue&type=script&lang=js&"
import style0 from "./TeakManagement.vue?vue&type=style&index=0&id=6d8ec1ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8ec1ba",
  null
  
)

export default component.exports